
<template>
  <div
    v-if="userId"
    :style="`background-image:url(/api/users/${userId}/avatar?random=${Math.floor(Math.random() * 100)});`"
    class="comment__user-profile-thum"
  >
  </div>
  <!-- <img
    v-if="userId"
    :src="`/api/users/${userId}/avatar?random=${avatar || ''}`"
  > -->
</template>

<script>
export default {
  props: {
    userId: { type: String }
  }
}
</script>
